import { c as _c } from "react/compiler-runtime";
import { Box, Button, Separator, LinkBox, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { DraggableImageBox } from '@src/components/sco/Account/DraggableImageBox';
import { UploadButton } from '@src/components/sco/Account/UploadButton';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { scoBackendUrl } from '@src/lib/startups-url';
import { range } from 'lodash';
import React, { useEffect, useState } from 'react';

// Placeholder images. we have 1 through 48 uploaded. This could be an array of URLs instead.
export const DEFAULT_COVER_PHOTO_URL_OPTIONS = range(1, 21).map(i => `https://s3.us-east-1.amazonaws.com/app-assets.startups.com/static/cover-photos/${i}.jpeg`);
export const DEFAULT_COVER_PHOTO_URL = 'https://s3.us-east-1.amazonaws.com/app-assets.startups.com/static/cover-photos/16.jpeg';
export type UserCoverPhotoSelectorProps = {
  onChange?: (url: string) => any;
  value?: string;
  defaultValue?: string;
  options?: string[];
  onPositionChange?: (position: {
    x: number;
    y: number;
  }) => void;
  initialPosition?: {
    x: number;
    y: number;
  };
  onDragEnd?: (position: {
    x: number;
    y: number;
  }) => void;
  disableDragEnd?: boolean;
};
export const UserCoverPhotoSelector = props => {
  const $ = _c(65);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [value, setValue] = useState(props.value || props.defaultValue);
  const [imagePosition, setImagePosition] = useState(props.initialPosition);
  const urlOptions = props.options || DEFAULT_COVER_PHOTO_URL_OPTIONS;
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  let t1;
  if ($[0] !== props.value) {
    t0 = () => {
      setValue(props.value);
    };
    t1 = [props.value];
    $[0] = props.value;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== props.initialPosition) {
    t2 = () => {
      console.log("UserCoverPhotoSelector: initialPosition prop changed:", props.initialPosition);
      setImagePosition(props.initialPosition);
    };
    t3 = [props.initialPosition];
    $[3] = props.initialPosition;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== props) {
    t4 = url => {
      console.log("UserCoverPhotoSelector: onChange called with URL:", url);
      setValue(url);
      console.log("UserCoverPhotoSelector: Resetting imagePosition to undefined");
      setImagePosition(undefined);
      if (props.onChange) {
        props.onChange(url);
      }
    };
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onChange = t4;
  let t5;
  if ($[8] !== props) {
    t5 = () => {
      setValue(null);
      setImagePosition(undefined);
      if (props.onChange) {
        props.onChange(null);
      }
    };
    $[8] = props;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onClear = t5;
  let t6;
  if ($[10] !== props) {
    t6 = position => {
      if (props.onPositionChange) {
        props.onPositionChange(position);
      }
    };
    $[10] = props;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onPositionChange = t6;
  let t7;
  if ($[12] !== props) {
    t7 = position_0 => {
      if (props.onDragEnd) {
        props.onDragEnd(position_0);
      }
    };
    $[12] = props;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const onDragEnd = t7;
  let t8;
  if ($[14] !== imagePosition || $[15] !== onDragEnd || $[16] !== onPositionChange || $[17] !== props.disableDragEnd || $[18] !== value) {
    t8 = value && <DraggableImageBox disableDragEnd={props.disableDragEnd} initialPosition={imagePosition} src={value} onDragEnd={onDragEnd} onPositionChange={onPositionChange} />;
    $[14] = imagePosition;
    $[15] = onDragEnd;
    $[16] = onPositionChange;
    $[17] = props.disableDragEnd;
    $[18] = value;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <Box textAlign="center">{t8}</Box>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== getBreakpointValue) {
    t10 = getBreakpointValue(["column", "row"]);
    $[22] = getBreakpointValue;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onChange) {
    t11 = url_0 => onChange(url_0);
    $[24] = onChange;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["jpeg", "jpg", "png"];
    t13 = {
      size: "sm"
    };
    $[26] = t12;
    $[27] = t13;
  } else {
    t12 = $[26];
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = scoBackendUrl("/assets/upload-cover-image");
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = currentUser?.userId;
  let t16;
  if ($[29] !== t15) {
    t16 = {
      attachmentType: "User",
      attachmentId: t15,
      contextKey: "profile-picture"
    };
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t11 || $[32] !== t16) {
    t17 = <Box><UploadButton afterError={_temp} afterSuccess={t11} allowedExtensions={t12} buttonProps={t13} maxSizeInBytes={10000000} uploadUrl={t14} storedFile={t16}>Upload a Profile Photo</UploadButton></Box>;
    $[31] = t11;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== onClear) {
    t18 = <Button size="sm" variant="outline" onClick={onClear}>Clear</Button>;
    $[34] = onClear;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t10 || $[37] !== t17 || $[38] !== t18) {
    t19 = <Stack align="center" direction={t10} justify="center" width="full">{t17}{t18}</Stack>;
    $[36] = t10;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text color="colorPalette.fg/60" fontSize="0.9em" marginTop="0.5em" textAlign="center">Tip: Choose a 1200 pixel-wide, high-resolution JPEG or PNG under 10MB.</Text>;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t19) {
    t21 = <Box width="full">{t19}{t20}</Box>;
    $[41] = t19;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Separator />;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== getBreakpointValue) {
    t23 = getBreakpointValue(["labelSm", "labelSm", "labelMd"]);
    $[44] = getBreakpointValue;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t23) {
    t24 = <Text textAlign="center" textStyle={t23} width="full">Or choose one of our default photos</Text>;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== getBreakpointValue) {
    t25 = getBreakpointValue([2, 2, 2]);
    $[48] = getBreakpointValue;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== onChange || $[51] !== urlOptions || $[52] !== value) {
    let t27;
    if ($[54] !== onChange || $[55] !== value) {
      t27 = (optionUrl, idx) => <LinkBox key={idx} _hover={{
        borderColor: value == optionUrl ? "colorPalette.border" : "whiteAlpha.500"
      }} backgroundColor="black" backgroundImage={`url('${optionUrl}')`} backgroundPosition="50% 50%" backgroundRepeat="no-repeat" backgroundSize="100% auto" border="2px solid" borderColor={value == optionUrl ? "colorPalette.border" : "transparent"} borderRadius="md" cursor="pointer" paddingBottom="40%" onClick={() => onChange(optionUrl)} />;
      $[54] = onChange;
      $[55] = value;
      $[56] = t27;
    } else {
      t27 = $[56];
    }
    t26 = urlOptions.map(t27);
    $[50] = onChange;
    $[51] = urlOptions;
    $[52] = value;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[57] !== t25 || $[58] !== t26) {
    t27 = <Box bgColor="blackAlpha.400" borderRadius="md" boxShadow="inset" maxHeight="50vh" overflow="auto" padding={4}><SimpleGrid columns={t25} gap={2} overflowY="auto">{t26}</SimpleGrid></Box>;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t21 || $[61] !== t24 || $[62] !== t27 || $[63] !== t9) {
    t28 = <Box><VStack align="stretch" gap={4}>{t9}{t21}{t22}{t24}{t27}</VStack></Box>;
    $[60] = t21;
    $[61] = t24;
    $[62] = t27;
    $[63] = t9;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  return t28;
};
function _temp(err) {
  return alert(`Upload failed: ${err.toString()}`);
}